export default __webpack_public_path__ + "static/media/12_photo.0f8fcda1.jpg";